import { HttpClient, HttpContext, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import type { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import type { TableSort } from '../../components/table-sort/table-sort.models';
import { ACTION_ERROR_TITLE } from '../../interceptors/http-error.interceptor';
import type { Page } from '../../models/api/page.model';
import type {
  CreatePersonalTravelTransaction,
  PersonalTravelTransaction,
  PersonalTravelTransactionFilter,
} from '../../models/api/personal-travel-transaction.model';

@Injectable({
  providedIn: 'root',
})
export class PersonalTravelService {
  private readonly httpClient = inject(HttpClient);
  private readonly personalTravelApi = `${environment.apiUrl}/v1/personal-travel`;

  getPersonalTravelTransactions(
    pageNo: number,
    filter?: PersonalTravelTransactionFilter,
    sort?: TableSort,
  ): Observable<Page<PersonalTravelTransaction>> {
    const context = new HttpContext().set(
      ACTION_ERROR_TITLE,
      'Failed to Get Personal Travel Transactions',
    );

    let params = new HttpParams().set('page', pageNo).set('size', 10);

    if (filter) {
      Object.entries(filter)
        .filter(([, value]) => value !== undefined)
        .forEach(([key, value]) => (params = params.set(key, value)));
    }
    if (sort) params = params.set('sort', `${sort.sortId},${sort.direction}`);

    return this.httpClient.get<Page<PersonalTravelTransaction>>(
      `${this.personalTravelApi}/transactions`,
      { context, params },
    );
  }

  getPersonalTravelTransaction(transactionId: number): Observable<PersonalTravelTransaction> {
    const context = new HttpContext().set(
      ACTION_ERROR_TITLE,
      'Failed to Get Personal Travel Transaction',
    );

    return this.httpClient.get<PersonalTravelTransaction>(
      `${this.personalTravelApi}/transactions/${transactionId}`,
      { context },
    );
  }

  createPersonalTravelTransaction(
    personalTravel: CreatePersonalTravelTransaction,
  ): Observable<PersonalTravelTransaction> {
    const context = new HttpContext().set(
      ACTION_ERROR_TITLE,
      'Failed to Create Personal Travel Transaction',
    );

    return this.httpClient.post<PersonalTravelTransaction>(
      `${this.personalTravelApi}/add-new-expense`,
      personalTravel,
      { context },
    );
  }
}
